import { render, staticRenderFns } from "./undevelop.vue?vue&type=template&id=5f8d26fa&scoped=true"
import script from "./undevelop.vue?vue&type=script&lang=js"
export * from "./undevelop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8d26fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8d26fa')) {
      api.createRecord('5f8d26fa', component.options)
    } else {
      api.reload('5f8d26fa', component.options)
    }
    module.hot.accept("./undevelop.vue?vue&type=template&id=5f8d26fa&scoped=true", function () {
      api.rerender('5f8d26fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/undevelop.vue"
export default component.exports